import {
  CustomFieldValidatorState,
  DocumentElement,
  DocumentElementType,
  DocumentInstance,
  FieldProp,
} from '../types'

/**
 * Given an array of DocumentElements
 * Filter to only those which accept input values
 */
export function getInputDocumentElements(
  elements: DocumentElement[],
): DocumentElement[] {
  return elements.filter(
    element =>
      ![DocumentElementType.TEXT, DocumentElementType.PAGE_BREAK].includes(
        element.type,
      ),
  )
}

export function isSigned(document: DocumentInstance) {
  return document.status === 'COMPLETE'
}

export function createDocumentElementField(
  element: DocumentElement,
): FieldProp | null {
  switch (element.type) {
    case DocumentElementType.TEXT_FIELD:
      return {
        initialValue: element.value,
        label: element.label,
        name: element.label,
        validators: ['required'],
      }
    case DocumentElementType.MULTI_SELECT:
      return {
        initialValue: element.selectedOptionIds,
        label: element.label,
        name: element.label,
        validators: [
          {
            validator: ({ value }: CustomFieldValidatorState) =>
              value?.length > 0,
            validatorName: 'required',
          },
        ],
      }
    case DocumentElementType.SINGLE_SELECT:
      return {
        initialValue: element.options.find(
          ({ id }) => id === element.selectedOptionId,
        )?.name,
        label: element.label,
        name: element.label,
        validators: [
          {
            validator: ({ value }: CustomFieldValidatorState) => value,
            validatorName: 'required',
          },
        ],
      }
    case DocumentElementType.SINGLE_CHECKBOX:
      return {
        initialValue: element.selected,
        label: element.label,
        name: element.label || element.id,
        type: 'toggle',
        validators: [],
      }
    case DocumentElementType.DATE:
      return {
        initialValue: element.date,
        label: element.label,
        name: element.label,
        validators: ['required'],
      }
    case DocumentElementType.DATE_TIME:
      return {
        initialValue: element.dateTime,
        label: element.label,
        name: element.label,
        validators: ['required'],
      }
    case DocumentElementType.SIGNATURE:
      return {
        initialValue: {
          signature: element.signature,
          signer: element.signer,
        },
        label: element.label,
        name: element.label || element.id,
        validators: [
          {
            validator: ({ value }: CustomFieldValidatorState) =>
              Boolean(value?.signature && value?.signer),
            validatorName: 'required',
          },
        ],
      }
    case DocumentElementType.PAGE_BREAK:
      return null
    default:
      throw new Error('Unsupported document element type provided')
  }
}
